import { useMemo } from 'react'

import type { PreviewMode } from 'services/Store/Project/enums'

import type { CheckboxElementType } from '../checkboxTypes'
import CheckboxElementEditor from './CheckboxElementEditor'
import CheckboxElementPreview from './CheckboxElementPreview'

const COMPONENTS_MAP: Partial<Record<PreviewMode, CheckboxElementType>> = {
  editor: CheckboxElementEditor,
}

const CheckboxElement: CheckboxElementType = ({ mode, ...rest }) => {
  const initialMergedState = useMemo(
    () => ({
      items: rest.element.value.items.map((item) => {
        const foundItem = (rest.state?.items || []).find((i) => i.value === item.value)
        return {
          ...item,
          disabled: Boolean(foundItem?.disabled),
          checked: Boolean(foundItem?.checked),
        }
      }),
    }),
    [rest.state?.items, rest.element.value.items],
  )
  const Component = COMPONENTS_MAP[mode.previewMode] || CheckboxElementPreview
  return <Component mode={mode} {...rest} state={initialMergedState} />
}

export default CheckboxElement
